// extracted by mini-css-extract-plugin
export default {"catalogCardsButton":"CatalogCardsButton_catalogCardsButton__N+HHL"};